function l(u, n, e) {
  const t = u.slice(0, n);
  for (; t.length < n; )
    t.push(e ?? null);
  return t;
}
export {
  l as toFixedLengthArray
};
//# sourceMappingURL=index.es.js.map
